import * as orders from "./orders";

export const shop = {
    ...orders
}